import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context";
import DividerLine from "../components/divider-line";
import { ROOT } from "../dataHooks";
import dividerStyles from "../statics/styles/divider-viewer.rtlignore-scss";
const DividerViewer = ({ componentData }) => {
  const { isMobile } = useContext(RicosContext);
  const lineStyle = componentData.lineStyle?.toLowerCase();
  const className = classNames(
    dividerStyles["divider-container"],
    dividerStyles[`divider-container--${lineStyle}`],
    isMobile && dividerStyles["divider-container--mobile"]
  );
  return /* @__PURE__ */ React.createElement("div", { className, "data-hook": `${ROOT} divider-${lineStyle}` }, /* @__PURE__ */ React.createElement(
    DividerLine,
    {
      type: lineStyle,
      width: "100%",
      size: componentData.width?.toLowerCase(),
      alignment: componentData.alignment?.toLowerCase(),
      styles: dividerStyles,
      isMobile
    }
  ));
};
export {
  DividerViewer
};
//# sourceMappingURL=divider-viewer.js.map
